import { createContext, ReactNode, useCallback, useState, useMemo } from 'react'
import { GetAllPermissionarios } from 'services/permissionariosService'

interface LoadDataContextProps {
  allRegistersPermissionarios: any[]
  setAllRegistersPermissionarios: React.Dispatch<React.SetStateAction<any[]>>
  loadAllPermissionarios: boolean
  setLoadAllPermissionarios: React.Dispatch<React.SetStateAction<boolean>>
  carregaTodosPermissionarios: () => void
}

interface LoadDataContextProviderProps {
  children: ReactNode
}

export const LoadDataContext = createContext({} as LoadDataContextProps)

export function LoadDataContextProvider({ children }: LoadDataContextProviderProps) {
  const [allRegistersPermissionarios, setAllRegistersPermissionarios] = useState([])
  const [loadAllPermissionarios, setLoadAllPermissionarios] = useState(true)

  // Carrega a lista completa de permissionarios sob demanda (chamada pela tela de
  // Controle de Veiculos ao montar), em vez de em todo login independente da tela.
  const carregaTodosPermissionarios = useCallback(() => {
    setLoadAllPermissionarios(true)
    GetAllPermissionarios().then((response) => {
      setAllRegistersPermissionarios(response.data.data.permissionarios)
      setLoadAllPermissionarios(false)
    })
  }, [])

  const contextValues = useMemo(
    () => ({
      allRegistersPermissionarios,
      setAllRegistersPermissionarios,
      loadAllPermissionarios,
      setLoadAllPermissionarios,
      carregaTodosPermissionarios
    }),
    [allRegistersPermissionarios, loadAllPermissionarios, carregaTodosPermissionarios]
  )

  return <LoadDataContext.Provider value={contextValues}>{children}</LoadDataContext.Provider>
}
